import styled from '@emotion/styled';
import React, { useState } from 'react';
import ClientOrderRow from './ClientOrderRow';
import { Order } from '../types';
import { SortIcon, SortIconBox, SortIconActive, LargeLegacyIcon, HelpIcon } from '../../components/icons';
import Button from '../../components/Button';
import { useEffect } from 'react';
import ToolTip from '../../components/ToolTip';
import moment from 'moment';

const Wrapper = styled.div`
  margin-top: 42px;
`;
const RecentOrdersStyles = styled.div`
  color: #93918f;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  text-transform: uppercase;
  position: relative;
  @media (min-width: 768px) {
    font-weight: 600;
    font-size: 24px;
    color: #444340;
    text-transform: capitalize;
  }
`;
const HeaderRow = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 20% 15% 37% 25%;
    grid-column-gap: 1%;
    color: #93918f;
    font-size: 10px;
    margin: 26px 0 8px 0;
    text-align: left;
  }
`;
const SortStyles = styled.div`
  cursor: pointer;
`;
const SortOpenStyles = styled.div`
  position: absolute;
  background-color: #fff;
  border: 1px solid #000000;
  padding: 24px 40px 24px 24px;
  border-radius: 3px;
  right: 0;
  top: 46px;
`;
const SortOptionStyles = styled.div`
  margin-top: 8px;
  font-size: 16px;
  cursor: pointer;
  padding-top: 8px;
  color: #444340;
  :hover {
    color: #93918f;
  }
`;
const SortIconMobile = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;
const SortIconDesktop = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: block;
    height: 40px;
    width: 40px;
    border-radius: 5px;
    :hover {
      background-color: #f5f5f5;
    }
  }
`;

interface Props {
  orders: Order[];
  legacyOrders: Order[];
  onClickUpdated?: () => void;
  onClick: (sortBy: string) => void;
  onClickClear?: () => void;
  searchActive?: boolean;
  filterActive?: boolean;
  lastLegacyDate?: Date;
  searchText: string;
}

const sortOptions = [
  {
    key: 'lastUpdated',
    value: 'Last Updated',
  },
  {
    key: 'orderDate',
    value: 'Date Ordered',
  },
];

const ClientOrders = (props: Props) => {
  const [sortOpen, setSortOpen] = useState(false);

  useEffect(() => {
    window.addEventListener('click', () => {
      setSortOpen(false);
    });
    return () => {
      window.removeEventListener('click', () => {
        setSortOpen(false);
      });
    };
  }, []);

  return (
    <Wrapper>
      <RecentOrdersStyles>
        {!props.searchActive ? (
          <>
            <div>Search Results</div>
            {/* <Button buttonType="ButtonTertiarySmall" buttonText="Clear" onClick={props.onClickClear} /> */}
          </>
        ) : (
          <>
            <div>Recent Orders</div>
            {props.filterActive && (
              <SortStyles
                onClick={e => {
                  e.stopPropagation();
                  setSortOpen(!sortOpen);
                }}
              >
                <SortIconMobile>
                  <SortIcon />
                </SortIconMobile>
                <SortIconDesktop>
                  {sortOpen ? (
                    <SortIconActive style={{ borderRadius: 3 }} />
                  ) : (
                    <SortIconBox style={{ borderRadius: 3 }} />
                  )}
                </SortIconDesktop>
              </SortStyles>
            )}
            {sortOpen && (
              <SortOpenStyles>
                <div style={{ color: '#93918F', fontSize: 12 }}>SORT BY</div>
                {sortOptions.map(s => (
                  <SortOptionStyles key={s.key} onClick={() => (setSortOpen(false), props.onClick(s.key))}>
                    {s.value}
                  </SortOptionStyles>
                ))}
              </SortOpenStyles>
            )}
          </>
        )}
      </RecentOrdersStyles>
      {props.orders.length > 0 ? (
        <>
          <HeaderRow>
            <div>TITLE #</div>
            <div>DATE ORDERED</div>
            <div>PROPERTY</div>
            <div>CURRENT STATUS</div>
          </HeaderRow>
          {props.orders.map(o => (
            <ClientOrderRow key={o.id} order={o} searchText={props.searchText} />
          ))}
          {props.legacyOrders.length > 0 && props.lastLegacyDate && !props.filterActive && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <LargeLegacyIcon />
              <div style={{ padding: '10px 8px 10px 4px' }}>Archived Orders</div>
              <ToolTip
                toolTipText={`Limited data is available for orders placed before
          ${moment(props.lastLegacyDate).format('MM/DD/YYYY')}`}
              >
                <HelpIcon />
              </ToolTip>
            </div>
          )}
          {!props.filterActive &&
            props.legacyOrders.map(o => (
              <ClientOrderRow key={o.id} order={o} searchText={props.searchText} />
            ))}
        </>
      ) : (
        <div style={{ fontSize: 17, marginTop: 32, textAlign: 'center' }}>No Results Found</div>
      )}
    </Wrapper>
  );
};

export default ClientOrders;
